<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Saques
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" persistent max-width="700px">
          <v-card class="card-rounded">
            <v-form @submit.prevent="saveSaque" ref="saqueForm" lazy-validation>
              <v-card-title>
                <span class="headline">Solicitação de Saque</span>
              </v-card-title>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="6" xl="6" lg="6" md="6" sm="12">
                      <v-input> Usuário: {{ saque.email }} </v-input>
                    </v-col>
                    <v-col cols="6" xl="6" lg="6" md="6" sm="12">
                      <v-input> Nome: {{ saque.nome }} </v-input>
                    </v-col>
                    <v-col cols="6" xl="6" lg="6" md="6" sm="12">
                      <v-input> CPF: {{ userProfile.cpf }} </v-input>
                    </v-col>
                    <v-col cols="6" xl="6" lg="6" md="6" sm="12">
                      <v-input>
                        Tipo Saque:
                        {{ saque.tipo_saque == "pix" ? "Pix" : "Depósito" }}
                      </v-input>
                    </v-col>
                    <v-col
                      v-if="
                        saque.tipo_saque == 'deposito' ||
                          saque.tipo_saque == null
                      "
                      cols="6"
                      xl="6"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <v-input> Banco: {{ userProfile.banco }} </v-input>
                    </v-col>
                    <v-col
                      v-if="
                        saque.tipo_saque == 'deposito' ||
                          saque.tipo_saque == null
                      "
                      cols="6"
                      xl="6"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <v-input> Agencia: {{ userProfile.agencia }} </v-input>
                    </v-col>
                    <v-col
                      v-if="
                        saque.tipo_saque == 'deposito' ||
                          saque.tipo_saque == null
                      "
                      cols="6"
                      xl="6"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <v-input>
                        Tipo da Conta:
                        {{
                          userProfile.tipoConta == "CC"
                            ? "Conta Corrente"
                            : userProfile.tipoConta == "CP"
                            ? "Conta Poupança"
                            : ""
                        }}
                      </v-input>
                    </v-col>
                    <v-col
                      v-if="
                        saque.tipo_saque == 'deposito' ||
                          saque.tipo_saque == null
                      "
                      cols="6"
                      xl="6"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <v-input> Conta: {{ userProfile.conta }} </v-input>
                    </v-col>
                    <v-col
                      v-if="saque.tipo_saque == 'pix'"
                      cols="6"
                      xl="6"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <v-input>
                        Tipo da chave:
                        {{
                          saque.tipo_pix == "cpf"
                            ? "CPF"
                            : saque.tipo_pix == "email"
                            ? "Email"
                            : "Telefone"
                        }}
                      </v-input>
                    </v-col>
                    <v-col
                      v-if="saque.tipo_saque == 'pix'"
                      cols="6"
                      xl="6"
                      lg="6"
                      md="6"
                      sm="12"
                    >
                      <v-input> Chave: {{ saque.chave_pix }} </v-input>
                    </v-col>
                    <v-col cols="6" xl="6" lg="6" md="6" sm="12">
                      <v-input>
                        Valor Solicitado:
                        {{ formatValue(saque.valor_solicitado) }}
                      </v-input>
                    </v-col>
                    <v-col cols="6" xl="6" lg="6" md="6" sm="12">
                      <v-input>
                        Desconto: {{ formatValue(saque.desconto) }}
                      </v-input>
                    </v-col>
                    <v-col cols="6" xl="6" lg="6" md="6" sm="12">
                      <v-input>
                        Valor saque: {{ formatValue(saque.valor) }}
                      </v-input>
                    </v-col>
                    <v-col cols="6" xl="6" lg="6" md="6" sm="12">
                      <v-input> Data: {{ formatDate(saque.data) }} </v-input>
                    </v-col>
                    <v-col cols="6" xl="6" lg="6" md="6" sm="12">
                      <v-select
                        :items="opcoes"
                        label="Status"
                        item-text="label"
                        item-value="value"
                        required
                        v-model="saque.status"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  :disabled="updateLoading"
                  color="primary"
                  text
                  @click.native="closeDialog"
                >
                  Fechar
                </v-btn>
                <v-btn
                  :disabled="updateLoading"
                  color="primary"
                  text
                  type="submit"
                >
                  Salvar
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-card-title>
      <v-card-text>
        <v-radio-group v-model="filtro" row>
          <v-radio label="Todas" value="TODAS"></v-radio>
          <v-radio label="Em Aberto" value="ABERTO"></v-radio>
          <v-radio label="Concluídas" value="CONCLUIDA"></v-radio>
          <v-radio label="Canceladas" value="CANCELADA"></v-radio>

          <v-btn color="primary" dark @click="filtrar()">Filtrar</v-btn>
        </v-radio-group>

        <v-data-table
          :headers="headers"
          :items="saques"
          :items-per-page="10"
          :loading="fetchSaqueLoading"
          :no-data-text="
            fetchSaqueLoading ? 'Carregando' : 'Nenhum Registro para mostrar'
          "
          class="elevation-1"
        >
          <template v-slot:[`item.data`]="{ item }">
            <span>{{ formatDate(item.data) }}</span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <span>{{
              item.status == "CONCLUIDO"
                ? "Concluída"
                : item.status == "CANCELADO"
                ? "Cancelado"
                : "Em Aberto"
            }}</span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <span style="margin-right: 10px;">
              <v-icon small @click="editItem(item)">edit</v-icon></span
            >
            <span>
              <v-icon small @click="deleteItem(item)">delete</v-icon></span
            >
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <app-delete-dialog
      msg="Deseja Remover o saque selecionado?"
      :dialogDelete="deleteDialog"
      :id="selectedId"
      @onConfirmDelete="onConfirmDelete($event)"
      @onCancelDelete="deleteDialog = false"
    ></app-delete-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import util from "@/service/util-service";
import DeleteDialog from "@/views/delete/DeleteDialog";

export default {
  components: {
    "app-delete-dialog": DeleteDialog,
  },
  data() {
    return {
      filtro: "TODAS",
      dialog: false,
      isInsert: true,
      userProfile: {},
      headers: [
        { text: "", value: "actions", sortable: false },
        {
          text: "Usuário",
          align: "left",
          sortable: true,
          value: "nome",
        },
        {
          text: "Status",
          align: "left",
          sortable: true,
          value: "status",
        },
        {
          text: "Data",
          align: "left",
          sortable: true,
          value: "data",
        },
        {
          text: "valor",
          align: "left",
          sortable: true,
          value: "valor",
        },
      ],
      fetchSaqueLoading: false,
      updateLoading: false,
      saque: {},
      deleteDialog: false,
      selectedId: 0,
      acessoKey: 0,
      opcoes: [
        { label: "Em Aberto", value: "ABERTO" },
        { label: "Concluído", value: "CONCLUIDO" },
      ],
    };
  },
  watch: {
    dialog(v) {
      if (v) {
      }
    },
  },
  computed: {
    ...mapGetters({
      saques: "saques",
    }),
  },
  created() {
    this.getSaques();
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("T")[0].split("-");
      return `${day}/${month}/${year}`;
    },
    filtrar() {
      if (this.filtro == "TODAS") {
        this.getSaques();
      } else {
        this.getSaquesByStatus();
      }
    },
    closeDialog() {
      this.dialog = false;
    },
    createRules() {
      this.userRules = [(v) => !!v || "Email do usuário é obrigatório"];
    },
    resetForm() {
      if (this.$refs.saqueForm) {
        this.$refs.saqueForm.reset();
      }
    },

    validateForm() {
      if (this.$refs.saqueForm.validate()) {
        return true;
      }
      return false;
    },
    getProfile(idUser) {
      this.fetchSaqueLoading = true;
      this.$store
        .dispatch("fetchProfileById", idUser)
        .then((value) => {
          this.userProfile = value;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.fetchSaqueLoading = false;
        });
    },
    getSaques() {
      this.fetchSaqueLoading = true;
      this.$store
        .dispatch("getSaques")
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.fetchSaqueLoading = false;
        });
    },
    getSaquesByStatus() {
      this.fetchSaqueLoading = true;
      this.$store
        .dispatch("getSaquesByStatus", this.filtro)
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.fetchSaqueLoading = false;
        });
    },

    saveSaque() {
      if (this.validateForm()) {
        if (this.saque.status == "CONCLUIDO") {
          this.fetchSaqueLoading = true;
          this.$store
            .dispatch("aprovarSaque", this.saque)
            .then((value) => {
              if (value.type == "ok") {
                this.$store.dispatch("setNotification", {
                  type: "success",
                  text: value.msg,
                });
                this.dialog = false;
                this.filtrar();
              } else {
                this.$store.dispatch("setNotification", {
                  type: "error",
                  text: value.msg,
                });
              }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              this.fetchSaqueLoading = false;
            });
        }
      }
    },

    editItem(item) {
      this.getProfile(item.idUser);
      this.isInsert = false;
      this.saque = item;
      this.acesso = item;
      this.acessoKey += 1;
      this.dialog = true;
    },
    deleteItem(item) {
      this.selectedId = item.id;
      this.deleteDialog = true;
    },
    onConfirmDelete(event) {
      this.deleteDialog = false;
      this.$store
        .dispatch("deleteSaque", event)
        .then((value) => {
          console.log(value);
          if (value.type == "error") {
            this.$store.dispatch("setNotification", {
              type: "error",
              text: value.msg,
            });
          } else {
            this.$store.dispatch("setNotification", {
              type: "success",
              text: value.msg,
            });
            this.filtrar();
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.updateLoading = false;
        });
    },
    formatValue(value) {
      if (value)
        return value.toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        });
      return "";
    },
  },
};
</script>
